import React, { useEffect, useState } from "react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Header from "./common/Header";
import Footer from "./common/Footer";
import MainRoutes from "./routes/MainRoutes";
import TripProcessPage from "./components/tripProcess";
import './i181n'; // Import i18n configuration

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(
    !!sessionStorage.getItem("auth")
  );

  useEffect(() => {
    setIsAuthenticated(!!sessionStorage.getItem("auth"));
  }, []);
  return (
    <>
      <Header
        isAuthenticated={isAuthenticated}
        setIsAuthenticated={setIsAuthenticated}
      />{" "}
      {/* Pass setIsAuthenticated to the Header component */}
      <div className="App">
        <TripProcessPage />
        <MainRoutes setIsAuthenticated={setIsAuthenticated} />{" "}
        {/* Pass setIsAuthenticated to the MainRoutes component */}
        <ToastContainer />
      </div>
      <Footer /> {/* Include the Footer component */}
    </>
  );
}

export default App;
